import { render, staticRenderFns } from "./dashboard-status-temp.vue?vue&type=template&id=35292ae3&scoped=true&"
import script from "./dashboard-status-temp.vue?vue&type=script&lang=js&"
export * from "./dashboard-status-temp.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-status-temp.vue?vue&type=style&index=0&id=35292ae3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35292ae3",
  null
  
)

export default component.exports